<template>
	<div class="head">
		<div class="head-left">
			<img class="head-icon" src="../../../assets/yq/tag.png" alt="">
			<span class="head-title">{{title}}</span>
		</div>

		<div class="date-b" v-if='tabData.length>0'>
			<span v-for="item in tabData" @click="velvetBtn(item.value)" :class="{ active: item.value == activeValue }">{{item.name}}</span>
			<!-- <span @click="velvetBtn(0)" :class="{ active: velvetStatus === 0 }">近7日</span>
			<span @click="velvetBtn(1)" :class="{ active: velvetStatus === 1 }">近3月</span>
			<span @click="velvetBtn(2)" :class="{ active: velvetStatus === 2 }">近6月</span>
			<span @click="velvetBtn(3)" :class="{ active: velvetStatus === 3 }">本年度</span> -->
		</div>

	</div>
</template>

<script>
	export default {

		props: {
			title: {
				type: String,
				default: '',
			},
			tabData: {
				type: Array,
				default:()=> [
					// {
					// 	name: '近7日',
					// 	value: '0'
					// },
					// {
					// 	name: '近15月',
					// 	value: '1'
					// },
					// {
					// 	name: '近30日',
					// 	value: '2'
					// },
				]
			}

		},
		data() {
			return {
				activeValue:'0'
			};
		},
		async created() {

		},

		methods: {

			velvetBtn(value){
				this.activeValue=value
				console.log(value)
			}

		},
	};
</script>
<style lang="scss" scoped>
	.head {
		height: 0.44rem;
		width: 100%;
		background: rgba(25, 236, 255, 0.06);
		border-radius: 0.05rem 0.05rem 0rem 0rem;
		padding-left: 0.16rem;
		display: flex;
		justify-content: space-between;

		.head-left {
			display: flex;
			align-items: center;
		}

		.head-icon {
			width: 0.33rem;
			height: 0.33rem;
			margin-right: 0.19rem;
		}

		.head-title {
			font-size: 0.23rem;
			font-family: Source Han Sans CN-Medium, Source Han Sans CN;
			font-weight: 500;
			color: #FFFFFF;
			line-height: 0.23rem;
		}

		.date-b {
			color: #7B8A8A;
			padding-right: 0.26rem;
			align-items: center;
			display: flex;

			span {
				display: inline-block;
				// width: 0.44rem;
				padding: .05rem;
				font-size: 0.13rem;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: 400;
				background: rgba(255, 255, 255, 0.05);
				// opacity: .5;
				border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
				cursor: pointer;
				text-align: center;
			}

			span:nth-child(2) {
				margin: 0 .13rem;
			}
			.active {
			            // opacity: 1 !important;
			            background: rgba(0,254,255,0.2);
						// opacity: 0.2;
			            color: #00FEFF;
			        }

		}


	}
</style>